
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './reducers/language.reducers';

export const selectDataState = createFeatureSelector<State>('languageData');

export const selectLanguageData = createSelector(selectDataState, (state) => state.languageData);
export const selectLanguageLoading = createSelector(selectDataState, (state) => state.loading);
export const selectLanguageError = createSelector(selectDataState, (state) => state.error);
